import { useContext, useEffect, useRef, useState } from 'react';
import './index.less'
import isBetween from 'dayjs/plugin/isBetween'; // 引入 isBetween 插件
import dayjs from 'dayjs';
import { ReactComponent as RightArrowSvg } from './icons/right-arrow.svg'
import { DatePicker } from 'tncet-common';
dayjs.extend(isBetween);
interface Iprops {
}

const fakeData = [
    { date: '2024-09-20', name: '巡检报告.docx' },
    { date: '2024-09-20', name: '消防栓照片.jpg' },
    { date: '2024-09-20', name: '空调照片.jpg' },
    { date: '2024-08-12', name: '巡检报告.docx' },
    { date: '2024-08-12', name: '消防栓照片.jpg' },
    { date: '2024-08-12', name: '烟感器照片.jpg' },
    { date: '2024-08-12', name: '喷淋头照片.jpg' },
    { date: '2024-07-10', name: '巡检报告.docx' },
    { date: '2024-07-10', name: '消防栓照片.jpg' },
    { date: '2024-06-10', name: '巡检报告.docx' },
    { date: '2024-05-10', name: '巡检报告.docx' },
    { date: '2024-04-10', name: '巡检报告.docx' },
    { date: '2024-03-10', name: '巡检报告.docx' },
    { date: '2024-03-10', name: '喷淋头照片.jpg' },
    { date: '2024-02-10', name: '巡检报告.docx' },
    { date: '2024-01-10', name: '巡检报告.docx' },
];

export default function InspectPanel(props: Iprops) {
    const [startDate, setStartDate] = useState(dayjs().startOf('year').format('YYYY-MM-DD')); // 当前年的1月1日
    const [endDate, setEndDate] = useState(dayjs().format('YYYY-MM-DD')); // 当前日期


    const [inspectData, setInspectData] = useState([]); // 假数据作为初始化数据
    const [selectedItems, setSelectedItems] = useState([]); // 保存选中的项

    useEffect(() => {
        // 模拟从后端获取数据
        setTimeout(() => {
            setInspectData(fakeData);
        }, 100);
    }, []);

    // 根据选定的日期过滤数据
    const filteredData = inspectData.filter((item) => {
        const itemDate = dayjs(item.date, 'YYYY-MM-DD');
        const start = dayjs(startDate, 'YYYY-MM-DD');
        const end = dayjs(endDate, 'YYYY-MM-DD');
        return itemDate.isBetween(start, end, null, '[]'); // 使用 dayjs 的 isBetween
    });

    // 统计巡检报告次数
    const inspectCount = filteredData.filter(item => item.name.endsWith('.docx')).length;

    // 统计出现.jpg的月份数量
    const jpgMonths = new Set(
        filteredData.filter(item => item.name.endsWith('.jpg')).map(item => dayjs(item.date).format('YYYY-MM'))
    );
    const faultCount = jpgMonths.size;

    // 点击记录时的处理逻辑
    const handleRecordClick = (item, event) => {
        if (event.ctrlKey) {
            // Ctrl 被按下时多选
            setSelectedItems(prev =>
                prev.includes(item)
                    ? prev.filter(i => i !== item) // 如果已经选中，取消选中
                    : [...prev, item] // 否则添加到选中的列表
            );
        } else {
            // 单选：如果已经选中，则取消；否则只选中当前项
            setSelectedItems(prev =>
                prev.includes(item) ? [] : [item]
            );
        }
    };

    const isSelected = (item) => selectedItems.includes(item);


    return (
        <div className="inspect-panel">
            <div className="inspect-header">
                <div className="inspect-title">巡检记录</div>
            </div>
            <div className="inspect-counts">
                <div className="count-item">
                    <div className="count-label">巡检次数</div>
                    <div className="count-number-container">
                        <div className="count-number" style={{ color: '#1746C2' }}>{inspectCount}</div>
                        <span className="count-unit">次</span></div>
                </div>
                <div className="vertical-separator"></div>
                <div className="count-item">
                    <div className="count-label">故障次数</div>
                    <div className="count-number-container">
                        <div className="count-number" style={{ color: '#CE0000' }}>{faultCount}</div>
                        <span className="count-unit">次</span></div>
                </div>
            </div>
            <div className="inspect-dates">
                <DatePicker
                    value={dayjs(startDate, 'YYYY-MM-DD')}
                    onChange={(date) => setStartDate(date ? date.format('YYYY-MM-DD') : startDate)}
                    format="YYYY-MM-DD"
                />
                <div className="date-separator"><RightArrowSvg /></div>
                <DatePicker
                    value={dayjs(endDate, 'YYYY-MM-DD')}
                    onChange={(date) => setEndDate(date ? date.format('YYYY-MM-DD') : endDate)}
                    format="YYYY-MM-DD"
                />
            </div>
            <div className="inspect-list">
                {filteredData.length > 0 ? (
                    filteredData.map((item, index) => (
                        <div
                            key={index}
                            className={`inspect-record ${isSelected(item) ? 'selected' : ''}`} // 添加选中样式
                            onClick={(event) => handleRecordClick(item, event)} // 点击处理
                        >
                            <div className="record-date">{item.date}</div>
                            <div className="record-name">{item.name}</div>
                        </div>
                    ))
                ) : (
                    <div className="no-list">暂无记录</div>
                )}
            </div>
        </div>
    );
}